module.exports = __webpack_public_path__ + "img/3.a63c72cb.jpg";